import React from 'react';

export const HighlightReplyContext = React.createContext(null);
HighlightReplyContext.displayName = 'HighlightReplyContext';
